import React from 'react';

/**
 * Stroke chevron matching the sidebar collapse control in App.tsx.
 * Default orientation points left; use `direction` to rotate.
 */
export type ChevronDirection = 'left' | 'right' | 'up' | 'down';

export interface ChevronIconProps {
  size?: number;
  direction?: ChevronDirection;
  className?: string;
  style?: React.CSSProperties;
  /** When true, animates rotation (sidebar / accordion). */
  animated?: boolean;
  'aria-hidden'?: boolean | 'true' | 'false';
}

const DIRECTION_ROTATION_DEG: Record<ChevronDirection, number> = {
  left: 0,
  right: 180,
  up: 90,
  down: -90,
};

export const ChevronIcon: React.FC<ChevronIconProps> = ({
  size = 15,
  direction = 'left',
  className,
  style,
  animated = false,
  'aria-hidden': ariaHidden = true,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden={ariaHidden}
    style={{
      transform: `rotate(${DIRECTION_ROTATION_DEG[direction]}deg)`,
      transition: animated ? 'transform 0.2s ease' : undefined,
      display: 'block',
      flexShrink: 0,
      ...style,
    }}
  >
    <polyline points="15 18 9 12 15 6" />
  </svg>
);
